<template>
  <validation-observer ref="createContact">
    <b-form autocomplete="off" @submit.prevent="createContact">
      <b-row>
        <b-col xl="12">
          <b-card>
            <b-card-title class="mb-Login">
              {{ t('Contact Details') }}
            </b-card-title>
            <b-row>
              <!-- First Name -->
              <b-col cols="6">
                <b-form-group
                  :label="t('First Name')"
                  label-for="vi-first-name"
                  class="required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="First Name"
                    vid="vi-first-name"
                    rules="required|min:3"
                  >
                    <b-form-input
                      id="vi-first-name"
                      v-model="form.first_name"
                      type="text"
                      autocomplete="off"
                      :placeholder="t('First Name')"
                    />
                    <small class="text-danger">{{ t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Last Name -->
              <b-col cols="6">
                <b-form-group
                  :label="t('Last Name')"
                  label-for="vi-last-name"
                  class="required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Last Name"
                    vid="vi-last-name"
                    rules="required|min:3"
                  >
                    <b-form-input
                      id="vi-last-name"
                      v-model="form.last_name"
                      type="text"
                      autocomplete="off"
                      :placeholder="t('Last Name')"
                    />
                    <small class="text-danger">{{ t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  :label="t('Email')"
                  label-for="vi-email"
                  class="required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="vi-email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="vi-email"
                      v-model="form.email"
                      type="text"
                      autocomplete="off"
                      :placeholder="t('Email')"
                    />
                    <small v-if="errors[0]" class="text-danger">{{
                      t(errors[0])
                    }}</small>
                    <small v-else-if="serverErrors.email" class="text-danger">{{
                      t(serverErrors.email[0])
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  :label="t('Phone')"
                  label-for="vi-phone"
                  class="required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Phone"
                    vid="vi-phone"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="SmartphoneIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-phone"
                        v-model.number="form.phone"
                        type="text"
                        autocomplete="off"
                        :placeholder="t('Phone')"
                      />
                    </b-input-group>
                    <small v-if="errors[0]" class="text-danger">{{
                      t(errors[0])
                    }}</small>
                    <small v-else-if="serverErrors.phone" class="text-danger">{{
                      t(serverErrors.phone[0])
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group :label="t('Industry')" label-for="vi-industry">
                  <validation-provider
                    #default="{ errors }"
                    name="Industry"
                    vid="vi-industry"
                  >
                    <b-form-input
                      id="vi-industry"
                      v-model="form.industry"
                      type="text"
                      autocomplete="off"
                      :placeholder="t('Industry')"
                    />
                    <small class="text-danger">{{ t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group :label="t('Title')" label-for="vi-title">
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    vid="vi-title"
                  >
                    <b-form-input
                      id="vi-title"
                      v-model="form.title"
                      type="text"
                      autocomplete="off"
                      :placeholder="t('Title')"
                    />
                    <small class="text-danger">{{ t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group :label="t('Company')" label-for="vi-company">
                  <validation-provider
                    #default="{ errors }"
                    name="Company"
                    vid="vi-company"
                  >
                    <b-form-input
                      id="vi-company"
                      v-model="form.company"
                      type="text"
                      autocomplete="off"
                      :placeholder="t('company')"
                    />
                    <small class="text-danger">{{ t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <!-- reset and submit -->
        <b-col cols="12" class="text-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
          >
            {{ t('Submit') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="redirectToContactList"
          >
            {{ t('Cancel') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { BCol, BForm, BRow, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useUtils } from '@core/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required } from '@validations'
import store from '@/store'
import { hideLoader, showLoader } from '@/utils/common'

export default {
  name: 'CreateContact',
  components: {
    BRow,
    BButton,
    BCol,
    BForm,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  mixins: [],
  data() {
    return {
      required,
      form: {
        first_name: '',
        last_name: '',
        id: '',
        email: '',
        phone: '',
        industry: '',
        title: '',
        company: '',
      },
      serverErrors: {},
    }
  },
  computed: {},
  mounted() {
    if (this.$route.params.id) {
      document.getElementById('loading-bg').classList.add('loading-bg')

      this.form.id = this.$route.params.id
      store
        .dispatch('ManageContact/getContactById', { id: this.form.id })
        .then(response => {
          if (response.data.code === '200') {
            this.form = response.data.data
            this.form.id = this.$route.params.id
          }
          document.getElementById('loading-bg').classList.remove('loading-bg')
        })
        .catch(e => {
          // eslint-disable-next-line eqeqeq
          if (e.msg == 'Unauthenticated.') {
            this.$router.back()
            document.getElementById('loading-bg').classList.remove('loading-bg')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'No Permission',
                icon: 'Danger',
                variant: 'danger',
                text: '',
              },
            })
          }
        })
    } else {
      this.form.id = 0
    }
  },
  methods: {
    redirectToContactList() {
      this.$router.push('/contact-universe/contacts')
    },
    createContact() {
      this.$refs.createContact.validate().then(success => {
        if (success) {
          // eslint-disable-next-line eqeqeq
          if (this.form.id === 0) {
            this.addContact()
          } else {
            this.updateContact()
          }
        }
      })
    },
    async addContact() {
      showLoader()
      await store
        .dispatch('ManageContact/createContact', this.form)
        .then(response => {
          if (response.data.code === '200') {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `${response.data.msg}`,
                icon: 'Success',
                variant: 'success',
                text: '',
              },
            })
            hideLoader()
            this.redirectToContactList()
          } else if (response.data.code === '422') {
            this.serverErrors = response.data.errors
            hideLoader()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `${response.data.msg}`,
                icon: 'Danger',
                variant: 'danger',
                text: '',
              },
            })
            hideLoader()
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `${e.message}`,
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
          hideLoader()
        })
    },
    async updateContact() {
      showLoader()
      await store
        .dispatch('ManageContact/updateContact', this.form)
        .then(response => {
          if (response.data.code === '200') {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `${response.data.msg}`,
                icon: 'Success',
                variant: 'success',
                text: '',
              },
            })
            hideLoader()
            this.redirectToContactList()
          } else if (response.data.code === '422') {
            this.serverErrors = response.data.errors
            hideLoader()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `${response.data.msg}`,
                icon: 'Danger',
                variant: 'danger',
                text: '',
              },
            })
            hideLoader()
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `${e.message}`,
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
          hideLoader()
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.card-body {
  overflow: none;
}
#profile_photo_preview {
  text-align: center;
}
#profile_photo_preview img {
  padding: 10px;
  max-height: 164px;
  width: auto;
}
@media (max-width: 400px) {
  #profile_photo_preview img {
    width: 100%;
  }
}
</style>
